import React, { createContext, useContext, useMemo } from 'react';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/function-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

/**
 * Feature context is used to provide config settings across the JQL Builder.
 * Do not add settings that are known to change frequently, because this will cause a re-render of the entire JQL Builder.
 * If a setting is known to change frequently, it should be have their own context.
 */
const FeatureContext = createContext({
	verticalMode: false,
	shouldRenderToParent: true,
});

export const FeatureContextProvider = ({
	children,
	verticalMode,
	shouldRenderToParent,
}: {
	children: React.ReactNode;
	verticalMode: boolean;
	shouldRenderToParent: boolean;
}) => {
	const value = useMemo(
		() => ({
			verticalMode,
			shouldRenderToParent,
		}),
		[shouldRenderToParent, verticalMode],
	);

	return fg('list_lovability_improving_filters') ? (
		<FeatureContext.Provider value={value}>{children}</FeatureContext.Provider>
	) : (
		children
	);
};

const useVerticalModeNew = (): boolean => {
	const context = useContext(FeatureContext);
	return context.verticalMode;
};

export const useVerticalMode = functionWithCondition(
	() => fg('list_lovability_improving_filters'),
	useVerticalModeNew,
	() => false,
);

const useShouldRenderToParentNew = (): boolean => {
	const context = useContext(FeatureContext);
	return context.shouldRenderToParent;
};

export const useShouldRenderToParent = functionWithCondition(
	() => fg('list_lovability_improving_filters'),
	useShouldRenderToParentNew,
	() => true,
);
